import axios, { AxiosRequestConfig } from "axios";
import {
  convertFilterToWhereQuery,
  convertQueryString,
} from "./queryURL.utils";
import { ResponseAPIWithPagination } from "./API.types";
import { Filter } from "./useGenericAPI";

export interface getAllParam<T> {
  page?: number;
  pageSize?: number;
  filter?: Filter<T>;
  filterQuery?: string;
  orderBy?: string;
  search?: string;
  descSearch?: string;
}


export class APIGenerator<T, X, V> {
  private baseURL: string;
  private axiosConfig?: AxiosRequestConfig<any>;

  constructor(baseURL: string, axiosConfig?: AxiosRequestConfig<any>) {
    this.baseURL = baseURL;
  }

  public async getAll({
    page = 0,
    pageSize = 0,
    filter,
    orderBy,
    search,
    descSearch,
    filterQuery,
  }: getAllParam<V>) {
    const whereQuery = filter ? convertFilterToWhereQuery(filter) : filterQuery;
    const query = {
      currentPage: page + "",
      pageSize: pageSize + "",
      whereQuery: whereQuery || "",
      orderByQuery: orderBy || "",
      query: search || "",
      descSearch: descSearch || "",
    };
    const url = convertQueryString(this.baseURL, query);
    return (await axios.get<ResponseAPIWithPagination<T>>(url, this.axiosConfig)).data;
  }

  public async getSingle(id: string) {
    return (await axios.get<T>(`${this.baseURL}/${id}`,this.axiosConfig)).data;
  }

  public async create(data: X) {
    return (await axios.post<T>(this.baseURL, data, this.axiosConfig)).data;
  }

  public async update(id: string, data: X) {
    return (await axios.put<T>(`${this.baseURL}/${id}`, data, this.axiosConfig)).data;
  }

  public async delete(id: string) {
    return (await axios.delete<any>(`${this.baseURL}/${id}`,this.axiosConfig)).data;
  }
}
